"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeterInfo = void 0;
var date_fns_1 = require("date-fns");
var get_latest_confirmed_readings_1 = require("./get-latest-confirmed-readings");
// check status based on priority order from highest to lowest: error - due - warning - ok
var getMeterInfo = function (readings, meterType, latestBillingEndDate) {
    var currentDate = new Date();
    // If the billing date is in the past, we add a month to it.
    // This accounts for when the actual next billing period has no transactions yet.
    var nextReadingDate = latestBillingEndDate
        ? (0, date_fns_1.isBefore)(new Date(latestBillingEndDate), currentDate)
            ? (0, date_fns_1.format)((0, date_fns_1.addDays)((0, date_fns_1.addMonths)(latestBillingEndDate, 1), 1), 'yyyy-MM-dd')
            : (0, date_fns_1.format)((0, date_fns_1.addDays)(latestBillingEndDate, 1), 'yyyy-MM-dd')
        : '';
    var meterInfoDefault = {
        meterType: meterType,
        status: 'error',
        nextReadingDate: nextReadingDate,
        lastReadingDate: '',
    };
    if (!meterType) {
        return __assign(__assign({}, meterInfoDefault), { reason: 'noMeterType' });
    }
    if (!readings || readings.length <= 0) {
        return __assign(__assign({}, meterInfoDefault), { reason: 'noReadings' });
    }
    if (!latestBillingEndDate) {
        return __assign(__assign({}, meterInfoDefault), { reason: 'noBillingEndDate' });
    }
    if ((0, date_fns_1.isBefore)(new Date(nextReadingDate), currentDate)) {
        return __assign(__assign({}, meterInfoDefault), { reason: 'billingDateInPast' });
    }
    var lastActual = (0, get_latest_confirmed_readings_1.getLatestConfirmedReadings)(readings);
    if (!lastActual) {
        return __assign(__assign({}, meterInfoDefault), { reason: 'noLastActual' });
    }
    var lastReadingDateTime = lastActual.readingDateTime;
    meterInfoDefault.lastReadingDate = lastReadingDateTime;
    if (meterType === 'smart') {
        var latestSmart = (0, get_latest_confirmed_readings_1.getLatestSmartReading)(readings);
        var isSmartNonComm = !latestSmart ||
            Math.abs((0, date_fns_1.differenceInDays)(currentDate, latestSmart.readingDateTime)) >= 5;
        var hasRecentManual = Math.abs((0, date_fns_1.differenceInDays)(currentDate, lastReadingDateTime)) < 5;
        if (isSmartNonComm && hasRecentManual) {
            return __assign(__assign({}, meterInfoDefault), { status: 'ok', reason: 'recentManual' });
        }
        if (isSmartNonComm) {
            return __assign(__assign({}, meterInfoDefault), { status: 'warning', reason: 'smartNonComm' });
        }
    }
    if (meterType === 'traditional') {
        // next overdue when last reading is >30 days ago and next reading >5 days away
        var isNextReadOverDue = Math.abs((0, date_fns_1.differenceInDays)(currentDate, lastReadingDateTime)) > 30 &&
            Math.abs((0, date_fns_1.differenceInDays)(nextReadingDate, currentDate)) > 5;
        var nextReadingWindowStart = (0, date_fns_1.subDays)(nextReadingDate, 5);
        // next due when last reading is older than {next reading due date - 5 days} and next reading is <=5 days away
        var isNextMeterReadDue = (0, date_fns_1.isBefore)(lastReadingDateTime, nextReadingWindowStart) &&
            Math.abs((0, date_fns_1.differenceInDays)(nextReadingDate, currentDate)) <= 5;
        // reading recently received when last reading <=30 days ago and next reading >5 days away
        var isReadingRecentlyReceived = Math.abs((0, date_fns_1.differenceInDays)(currentDate, lastReadingDateTime)) <= 30 &&
            Math.abs((0, date_fns_1.differenceInDays)(nextReadingDate, currentDate)) > 5;
        // due but received is when today is in read window and so is the last read
        var isDueButReceived = (0, date_fns_1.isWithinInterval)(lastReadingDateTime, {
            start: nextReadingWindowStart,
            end: nextReadingDate,
        }) &&
            (0, date_fns_1.isWithinInterval)(currentDate, {
                start: nextReadingWindowStart,
                end: nextReadingDate,
            });
        if (isNextMeterReadDue) {
            return __assign(__assign({}, meterInfoDefault), { status: 'due', reason: 'tradReadingDue' });
        }
        if (isNextReadOverDue) {
            return __assign(__assign({}, meterInfoDefault), { status: 'warning', reason: 'tradReadingOverDue' });
        }
        if (isDueButReceived) {
            return __assign(__assign({}, meterInfoDefault), { status: 'ok', reason: 'isDueButReceived' });
        }
        if (isReadingRecentlyReceived) {
            return __assign(__assign({}, meterInfoDefault), { status: 'ok' });
        }
    }
    return __assign(__assign({}, meterInfoDefault), { status: 'ok' });
};
exports.getMeterInfo = getMeterInfo;
